import { Moment } from './constructor';

export function clone() {
    return new Moment(this);
}



//////////////////
// WEBPACK FOOTER
// ./~/moment/src/lib/moment/clone.js
// module id = 562
// module chunks = 0